import { Dayjs } from 'dayjs';
import { EnumStockType } from './enums/enum-stock-type.model';
import { EnumStockStayType } from './enums/enum-stock-stay-type.model';
import { EnumStockStatus } from './enums/enum-stock-status.model';
import { ICountry } from '../destination';
import { Product } from '../product';
import { Contract } from '../booking';
import { StockValue } from './stock-value.model';

export interface IStockProductDetail {
  id: number;
  name: string;
  reference: string;
}

export interface IStock {
  id?: number | null;
  reference?: string;
  name?: string;
  startDate?: Dayjs;
  endDate?: Dayjs;
  type?: EnumStockType;
  stayType?: EnumStockStayType;
  available?: boolean;
  updated?: Dayjs;
  country?: ICountry;
  products?: Product[];
  contracts?: Contract[];
  stockValues?: StockValue[];
  contractNames?: string[];
  productNames?: string[];
  removable?: boolean;
  companyId?: number | string;
  productInfos?: string[];
  productDetails?: IStockProductDetail[];
  defaultStatus?: EnumStockStatus;
  defaultValue?: number;
  defaultRetro?: number;
  defaultStatusAfter?: EnumStockStatus;
  defaultMonths?: number;
}

export class Stock implements IStock {
  constructor(
    public id?: number,
    public reference?: string,
    public name?: string,
    public startDate?: Dayjs,
    public endDate?: Dayjs,
    public type?: EnumStockType,
    public stayType?: EnumStockStayType,
    public available?: boolean,
    public updated?: Dayjs,
    public country?: ICountry,
    public products?: Product[],
    public contracts?: Contract[],
    public stockValues?: StockValue[],
    public removable?: boolean,
    public numberContract?: number,
    public numberProduct?: number,
    public companyId?: number,
    public productInfos?: string[],
    public productDetails?: IStockProductDetail[],
    public defaultStatus?: EnumStockStatus,
    public defaultValue?: number,
    public defaultRetro?: number,
    public defaultStatusAfter?: EnumStockStatus,
    public defaultMonths?: number
  ) {
    this.available = this.available || false;
  }
}
